import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import { FolderKanban, Users, MessageSquare, Inbox } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminDashboard = () => {
  const { getAuthHeader } = useAuth();
  const [stats, setStats] = useState({
    projects: 0,
    team: 0,
    testimonials: 0,
    inquiries: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [projectsRes, teamRes, testimonialsRes, inquiriesRes] = await Promise.all([
        axios.get(`${API}/projects`),
        axios.get(`${API}/team`),
        axios.get(`${API}/testimonials`),
        axios.get(`${API}/inquiries`, { headers: getAuthHeader() })
      ]);

      setStats({
        projects: projectsRes.data.length,
        team: teamRes.data.length,
        testimonials: testimonialsRes.data.length,
        inquiries: inquiriesRes.data.length
      });
    } catch (error) {
    }
  };

  const statCards = [
    { label: 'Projects', value: stats.projects, icon: FolderKanban, color: 'emerald' },
    { label: 'Team Members', value: stats.team, icon: Users, color: 'amber' },
    { label: 'Testimonials', value: stats.testimonials, icon: MessageSquare, color: 'emerald' },
    { label: 'Inquiries', value: stats.inquiries, icon: Inbox, color: 'amber' }
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="text-4xl font-playfair font-bold text-stone-900 mb-2">Dashboard</h1>
        <p className="text-stone-600">Welcome to DBK Group Of Companies Admin Panel</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <div
              key={stat.label}
              data-testid={`stat-${stat.label.toLowerCase().replace(' ', '-')}`}
              className="p-6 bg-white border border-stone-200 hover:border-emerald-900 transition-colors"
            >
              <div className={`p-3 bg-${stat.color}-900 text-white inline-block mb-4`}>
                <Icon className="w-6 h-6" />
              </div>
              <p className="text-3xl font-playfair font-bold text-stone-900 mb-2">{stat.value}</p>
              <p className="text-stone-600 uppercase tracking-widest text-xs">{stat.label}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="p-6 bg-white border border-stone-200">
          <h3 className="text-xl font-playfair font-bold text-stone-900 mb-4">Quick Actions</h3>
          <div className="space-y-3">
            <a
              href="/admin/projects"
              data-testid="quick-action-projects"
              className="block p-4 border border-stone-200 hover:border-emerald-900 hover:bg-stone-50 transition-colors"
            >
              <p className="font-bold text-stone-900">Manage Projects</p>
              <p className="text-stone-600 text-sm">Add, edit, or remove property listings</p>
            </a>
            <a
              href="/admin/inquiries"
              data-testid="quick-action-inquiries"
              className="block p-4 border border-stone-200 hover:border-emerald-900 hover:bg-stone-50 transition-colors"
            >
              <p className="font-bold text-stone-900">View Inquiries</p>
              <p className="text-stone-600 text-sm">Respond to customer inquiries</p>
            </a>
          </div>
        </div>

        <div className="p-6 bg-white border border-stone-200">
          <h3 className="text-xl font-playfair font-bold text-stone-900 mb-4">System Info</h3>
          <div className="space-y-3">
            <div className="flex justify-between py-2 border-b border-stone-100">
              <span className="text-stone-600">Total Projects</span>
              <span className="font-bold text-stone-900">{stats.projects}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-stone-100">
              <span className="text-stone-600">Team Members</span>
              <span className="font-bold text-stone-900">{stats.team}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-stone-100">
              <span className="text-stone-600">Client Testimonials</span>
              <span className="font-bold text-stone-900">{stats.testimonials}</span>
            </div>
            <div className="flex justify-between py-2">
              <span className="text-stone-600">Pending Inquiries</span>
              <span className="font-bold text-emerald-900">{stats.inquiries}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;